export const useGeneralStore = defineStore('general-store', {
    state: () => {
        return {
            mainMenuOpen: false,
            navBar: {},
            mainNavigationData: {},
            footerData: {},
            ctaCards: {},
            palette: 'palette--mma'
        };
    },

    getters: {
        isMainMenuOpen() {
            return this.mainMenuOpen;
        },
        activePalette() {
            return this.palette;
        }
    },

    actions: {
        // Menu overlay
        toggleMainMenu() {
            this.mainMenuOpen = !this.mainMenuOpen;
        },

        openMainMenu() {
            this.mainMenuOpen = true;
        },

        closeMainMenu() {
            this.mainMenuOpen = false;
        },

        setNavigation(navigation) {
            if (!navigation) {
                return;
            }

            if (navigation?.mainNavigation) {
                this.mainNavigationData = navigation?.mainNavigation;
            }

            if (navigation?.navBar) {
                this.navBar = navigation?.navBar;
            }

            if (navigation?.footer) {
                this.footerData = navigation?.footer;
            }
        },

        setPalette(palette) {
            this.palette = palette;
        },

        setCtaCards(cards) {
            this.ctaCards = cards;
        }
    }
});
